import { StarValue, Star } from './types';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';
import { faStar as fasStar } from '@fortawesome/pro-solid-svg-icons';
import { faStar, faStarHalfStroke } from '@fortawesome/pro-regular-svg-icons';

function getStarIcon(star: StarValue): IconLookup {
  switch (star) {
    default:
    case 0:
      return faStar;
    case 0.5:
      return faStarHalfStroke;
    case 1:
      return fasStar;
  }
}

export default function useReviewStars(productRating: number): Star[] {
  let rating = productRating;
  let starValues: StarValue[] = [];

  for (let i = 0; i < 5; i++) {
    if (rating - 1 >= 0) {
      starValues.push(1);
      rating = rating - 1;
    } else if (rating - 0.5 >= 0) {
      starValues.push(0.5);
      rating = rating - 0.5;
    } else {
      starValues.push(0);
    }
  }

  return starValues.map((starValue) => ({
    value: starValue,
    icon: getStarIcon(starValue),
  }));
}
